export class RestoreAwsEc2InstanceRequest {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "restoreAccountId",
            "baseName": "restoreAccountId",
            "type": "string",
            "format": ""
        },
        {
            "name": "destination",
            "baseName": "destination",
            "type": "AwsEc2InstanceRestoreDestination",
            "format": ""
        },
        {
            "name": "image",
            "baseName": "image",
            "type": "RestoreInstanceImageInput",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return RestoreAwsEc2InstanceRequest.attributeTypeMap;
    }
    constructor() {
    }
}
